
/**
 *  Api service to communicate with backend services
 */
class Api {
  /**
   *  Api constructor
   */
  constructor() {
    this.debugMode = process.env.DEBUG_MODE // See webpack.config.js
    this.apiHost = process.env.API_HOST // See webpack.config.js
  }

  /**
   *  Check the status of the fetch response
   *  @param   {object}  response  The response
   *  @throws  {Error}             If the server response is not "positive",
   *                               throws an error with server message
   *                               explanation
   *  @return  {object}            The success response
   */
  checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      return response.json().then((json) => Promise.reject(json))
    }
  }

  /**
   *  Make a request using fetch
   *  @param   {string}   path     Path to be fetched
   *  @param   {object}   options  Fetch configuration
   *  @param   {string}   token    Add this auth token to the headers
   *  @return  {Promise}           The fetch promise
   */
  makeRequest(path, options) {
    const url = path.indexOf('http') >= 0 ? path : this.apiHost + path
    let opts = {
      ...options,
      headers: {
        ...options.headers,
        'Content-Type': 'application/json',
      },
    }
    opts = {
      ...opts,
      headers: {
        ...opts.headers,
        'Content-Type': 'application/json',
      },
    }

    const gameToken = window.SessionStorage.getItem('gameToken')
    if (gameToken) Object.assign(opts.headers, { 'x-auth-token': gameToken })

    return fetch(url, opts)
      .then(this.checkStatus)
      .then((response) => response.json())
  }

  /**
   * Make a GET request
   * @param   {string}  path   The path to be requested
   * @param   {string}  token  Add this auth token to headers
   * @return  {object}         The response of the request
   */
  *get(path, options, token = null) {
    let opts = {
      ...options,
      method: 'GET',
      headers: {
        ...options.headers,
      },
    }
    const response = yield this.makeRequest(path, opts, token)
    return response
  }

  /**
   * Make a POST request
   * @param   {string}  path   The path to be requested
   * @param   {object}  data   The data to be added to request
   * @param   {string}  token  Add this auth token to headers
   * @return  {object}         The response of the request
   */
  *post(path, options, data, token = null) {
    let opts = {
      ...options,
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        ...options.headers,
      },
    }

    const response = yield this.makeRequest(path, opts, token)
    return response
  }
  /**
   * Make a PUT request
   * @param   {string}  path   The path to be requested
   * @param   {object}  data   The data to be added to request
   * @param   {string}  token  Add this auth token to headers
   * @return  {object}         The response of the request
   */
  *put(path, options, data, token = null) {
    let opts = {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        ...options.headers,
      },
    }

    const response = yield this.makeRequest(path, opts, token)
    return response
  }
}

export default new Api()
